import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { defer, EMPTY, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { IHomePageService, NavigationConfig } from './interfaces';
import { HOME_PAGE } from './opaque-tokens';

export abstract class BaseHomePageService implements IHomePageService {
  protected abstract router: Router;
  protected abstract route: ActivatedRoute;
  getPrimaryOutletRedirectUrl(homeUrl: string) {
    const { redirectUrl } = this.route.snapshot.queryParams as Record<string, string>;
    if (redirectUrl && !redirectUrl.startsWith('/')) {
      throw new Error('redirectUrl must start with /');
    }
    if (!redirectUrl) {
      return homeUrl;
    }
    const parts = redirectUrl.split('/').filter((part) => !!part && !part.includes('('));
    if (parts.length === 0) {
      return homeUrl;
    }
    return parts.join('/');
  }
  redirectToHome(navigationOptions: NavigationConfig) {
    return this.getHomeUrl().pipe(
      mergeMap((url) =>
        defer(() =>
          this.router.navigate([
            {
              outlets: {
                primary: this.getPrimaryOutletRedirectUrl(url),
                ...navigationOptions.outlets,
              },
            },
          ]),
        ).pipe(mergeMap(() => EMPTY)),
      ),
    );
  }
  abstract getHomeUrl(): Observable<string>;
}

@Injectable()
export class SimpleHomePageService extends BaseHomePageService implements IHomePageService {
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    @Inject(HOME_PAGE) private homePage: string,
  ) {
    super();
  }

  getHomeUrl(): Observable<string> {
    return of(this.homePage);
  }
}
